











































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { Job } from '@/models/jobs/job';
import { Locale } from '../../models/jobs/locale';
import { Latlong } from '../../models/jobs/latlong';
import { AlertConfigDetails } from '../../models/JobAlert/alertconfigdetails';
import { Filter } from '../../models/jobs/filter';
import { JobAlertUI } from '../../models/JobAlert/JobAlertUI';
import { CommonJobAlert } from '../../models/JobAlert/commonjobalert';
import { Geolocation } from '../../models/jobs/geolocation';
import VueToastr from '@deveodk/vue-toastr';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component
export default class SimilarJobsAlert extends Vue {
  $wlToastr: any;
  private email: string = '';
  private titleMessage = 'Interested in this job?';
  private createdJobAlert: boolean = false;
  private jobAlertMessage: string = '';
  private defaultFrequency: string = '03';
  private frequencyPicked: string = '';
  private errors = {
    email: '',
  };
  @Prop() jobDetail!: any[];
  $moment: any;

  createJobAlert() {
    if (!(this.jobDetail && this.jobDetail.length)) return;

    const job = this.jobDetail[0];
    const jobSkill =
      job.jobSkills && job.jobSkills.length ? job.jobSkills[0] : '';

    let locale = new Locale();
    locale.city = '';
    locale.state = '';
    locale.country = '';

    let latlong = new Latlong();
    latlong.latitude = vxm.jobs.latitude || job.facility.latitude;
    latlong.longitude = vxm.jobs.longitude || job.facility.longitude;

    const jobFilter = vxm.jobs.JobListParams;
    let geoLocation = new Geolocation();
    geoLocation.requestPref = 'LATLONG';

    const keywords = jobFilter && jobFilter.keywords ? jobFilter.keywords : '';
    const name = job.jobPostingName || keywords || 'All Jobs';
    const searchText = name || jobFilter.keywords;

    let alertConfigDetails = new AlertConfigDetails();
    alertConfigDetails.textCriteria = searchText;
    alertConfigDetails.latLong = latlong;
    alertConfigDetails.geoLocation = geoLocation;

    /*if(jobFilter.geoLocation && jobFilter.geoLocation.latLong && jobFilter.geoLocation.latLong.latitude) {
            geoLocation.locationType = 'administrative_area_level_1';
            geoLocation.locShortName = jobFilter.geoLocation.locale.state;
            geoLocation.latLong = jobFilter.geoLocation.latLong;
        } else */
    if (job.facility && job.facility.state) {
      geoLocation.locationType = 'administrative_area_level_1';
      geoLocation.locShortName = job.facility.state;
      geoLocation.latLong = latlong;
      alertConfigDetails.address = job.facility.name || '';
    } else {
      geoLocation.locationType = '';
      geoLocation.locShortName = '';
    }

    let jobAlertFilter = new Filter();
    jobAlertFilter.remoteJobType = 'Yes' === job.remoteJobType ? ['Yes'] : [];

    let jobAlert = new JobAlertUI();
    jobAlert.name = name;

    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const userProfile = vxm.users.myUserProfile;
    jobAlert.email = this.isLoggedIn ? userProfile.email : this.email;
    jobAlert.fullName = `${userProfile.firstName} ${userProfile.lastName}`;
    jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;
    jobAlert.alertConfigDetails = alertConfigDetails;
    jobAlert.filter = jobAlertFilter;
    jobAlert.status = 0;
    jobAlert.isActive = true;
    jobAlert.isValidated = false;

    if (!jobAlert.email) {
      this.errors.email = 'login.email.required';
    } else if (!jobAlert.email.match(emailformat)) {
      this.errors.email = 'login.email.invalid';
    } else {
      this.saveJobAlert(jobAlert);
    }
    console.log('errorString', this.errors.email);
  }

  validJobAlert(): boolean {
    let isValid = false;
    // vxm.jobs.JobListParams;
    /*if (this.keywords || this.addressSearchText) {
            isValid = true;
        } else {
            this.$wlToastr('error', this.$t('JobAlert_MandatoryTitleOrLocationMsg'));
            isValid = false;
        }
        return isValid;*/
    return true;
  }

  saveJobAlert(jobAlert: JobAlertUI) {
    const commonJobAlert = new CommonJobAlert();
    commonJobAlert.jobAlert = jobAlert;
    const respPromise: any = vxm.jobs.createCommonJobAlert(commonJobAlert);
    Promise.all([respPromise]).then(
      (response) => {
        let res = response[0];
        if (res) {
          if (res.success === true || res.jobAlertId) {
            jobAlert.id = res.jobAlertId;
            this.titleMessage = 'New job alert created!';
            this.jobAlertMessage = `Congrats, your job alert has been successfully created. You'll receive emails when we have similar jobs.`;
            this.createdJobAlert = true;
            this.$wlToastr(
              'success',
              this.$t('JobAlert_JobAlert').toString(),
              'Job alert successfully created.',
            );
          } else if (res.errorMessage) {
            this.$wlToastr(
              'error',
              res.errorMessage,
              this.$t('JobAlert_JobAlert').toString(),
            );
          }
        }
      },
      (err) => {
        this.$wlToastr('error', '', 'Job alert creation error');
      },
    );
    this.manageFrequency();
  }

  async manageFrequency() {
    // Manage frequency only for logged in users
    if (!vxm.users.isLoggedIn) return;

    const payload = {
      userId: vxm.users.myUserProfile.userId,
      frequency: this.frequencyPicked,
    };
    let respPromise = vxm.jobs.updateJobAlertFrequency(payload);
    const resp = await respPromise;
    if (resp.meta.success) {
      // this.$wlToastr('success', 'this.$t('jobalert-frequency-updated-message'));
    } else {
      this.$wlToastr('error', this.$t('jobalert-frequency-updated-failed'));
    }
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get userEmail() {
    return vxm.users.myUserProfile.email;
  }

  get companyCode() {
    return vxm.jobs.BrandingInfo.companycode;
  }

  mounted() {
    if (vxm.users.isLoggedIn) {
      vxm.jobs.getJobAlertsFrequency().then(
        (response) => {
          if (response) {
            this.frequencyPicked =
              response.data.frequency || this.defaultFrequency;
          }
        },
        (err) => {
          //this.$wlToastr("error", "Cannot load Job Alerts settings", "Job Alert");
        },
      );
    }
  }
}
